import siteConfig from '@/configurations/siteConfig';
import { COULEUR_PANNEAU_DEFAUT, LISTE_CATEGORIE_PANNEAU } from '@/configurations/configPanneau';
import { AZIMUT } from '@/services/gestionIconMarker/iconMarkerConf';
import { getImgPdv } from '@/services/general/general';
import { closestMarkerColor } from '../general/colorManager';

export const TAILLE_ICON_PLUS_GRAND = 70;
export const TAILLE_ICON_GRAND = 50;
export const TAILLE_ICON_PETIT = 38;
export const TAILLE_ICON_LARGEUR = 40;
export const TAILLE_ICON_HAUTEUR = 60;

const hauteurDuFichier = 2569;
const largeurDuFichier = 530;

function findAzimut(azimut) {
  const result = AZIMUT.find((option) => {
    return (azimut >= option.min && azimut <= option.max)
      || (option.min2 && azimut >= option.min2 && option.max2 && azimut <= option.max2);
  });
  if (result) return result.value;
  return 0;
}

function getCouleur(couleur) {
  return couleur || COULEUR_PANNEAU_DEFAUT;
}

function getPositionCouleurMarker(couleur) {
  return closestMarkerColor(getCouleur(couleur)).id;
}

export function iconColorGetter(colorDemande, tailleDemande, azimutDemande, afficherAzimut) {
  let color = LISTE_CATEGORIE_PANNEAU[0].couleur;
  if (colorDemande) color = colorDemande;
  let taille = tailleDemande;
  if (!taille) {
    taille = TAILLE_ICON_PETIT;
  }
  let azimut = azimutDemande;
  if (azimut === null || azimut === undefined || !afficherAzimut) {
    azimut = 'aucun';
  }
  azimut = findAzimut(azimut);
  const ratio = taille / TAILLE_ICON_HAUTEUR;
  const positionCouleur = getPositionCouleurMarker(color);
  return {
    url: require('@/assets/images/icon_marker/icons.png'),
    scaledSize: { width: largeurDuFichier * ratio, height: hauteurDuFichier * ratio, f: 'px', b: 'px' },
    size: { width: TAILLE_ICON_LARGEUR * ratio, height: taille, f: 'px', b: 'px' },
    origin: { x: azimut * TAILLE_ICON_LARGEUR * ratio, y: positionCouleur * TAILLE_ICON_HAUTEUR * ratio, f: 'px', b: 'px' },
  };
}

export function getIconPanneau(panneau) {
  const { categorie, azimut } = panneau;
  return iconColorGetter(getCouleur(categorie.couleur), TAILLE_ICON_GRAND, azimut, true);
}

function drawBull (img, couleur, azimut, index) {
  const rayon = 12;  // Rayon du cercle contenant le numéro du panneau
  
  // Création d'un objet canvas
  const canvas = document.createElement('canvas');
  const width = TAILLE_ICON_LARGEUR + rayon;  // Définition de la largeur du canvas
  const height = TAILLE_ICON_HAUTEUR + rayon;  // Définition de la hauteur du canvas
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d");

  // Position du marqueur dans le canvas
  const x = (AZIMUT.find(az => azimut >= az.min && azimut <= az.max)?.value ?? 0) * TAILLE_ICON_LARGEUR;
  const y = getPositionCouleurMarker(couleur) * TAILLE_ICON_HAUTEUR;

  // Dessin de l'image dans le canvas
  ctx.drawImage(img, x, y, TAILLE_ICON_LARGEUR, TAILLE_ICON_HAUTEUR, 0, rayon, TAILLE_ICON_LARGEUR, TAILLE_ICON_HAUTEUR);

  // Centre du cercle contenant le numéro du panneau
  const centreX = TAILLE_ICON_LARGEUR;
  const centreY = rayon + 5;

  // Dessin du cercle qui contiendra le numéro du panneau
  ctx.beginPath();
  ctx.arc(centreX, centreY, rayon, 0, Math.PI * 2, true);
  ctx.fillStyle = '#2C3E50';
  ctx.fill();

  // Insertion du numéro du panneau, centré dans le cercle
  const numero = `${index}`;
  const largeurDisponible = (rayon - 2) * 2;
  let taillePolice = 17;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillStyle = 'white';
  ctx.font = `bold ${taillePolice}px sans-serif`;
  // Réduction de la police tant que le numéro déborde du cercle (2 chiffres et plus)
  while (taillePolice > 8 && ctx.measureText(numero).width > largeurDisponible) {
    taillePolice -= 1;
    ctx.font = `bold ${taillePolice}px sans-serif`;
  }
  ctx.fillText(numero, centreX, centreY);

  // Retour du canvas sous forme d'image png
  const dataURL = canvas.toDataURL('image/png');
  return dataURL;
}

const PDV_HAUTEUR_LOGO = 44;
const PDV_LARGEUR_FOND_MIN = 44;
const PDV_LARGEUR_LOGO_MAX = 132;
const PDV_SURECHANTILLONNAGE = 3;

export function iconPointDeVente(img) {
  const largeurSource = img.naturalWidth || img.width;
  const hauteurSource = img.naturalHeight || img.height;
  const ratio = largeurSource && hauteurSource ? largeurSource / hauteurSource : 1;

  const largeurLogo = Math.min(PDV_HAUTEUR_LOGO * ratio, PDV_LARGEUR_LOGO_MAX);
  const hauteurLogo = largeurLogo / ratio;

  const width = Math.round(Math.max(largeurLogo, PDV_LARGEUR_FOND_MIN));
  const height = PDV_HAUTEUR_LOGO;

  const canvas = document.createElement('canvas');
  canvas.width = width * PDV_SURECHANTILLONNAGE;
  canvas.height = height * PDV_SURECHANTILLONNAGE;
  const ctx = canvas.getContext('2d');
  ctx.scale(PDV_SURECHANTILLONNAGE, PDV_SURECHANTILLONNAGE);
  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = 'high';

  const decalageX = (width - largeurLogo) / 2;
  const decalageY = (PDV_HAUTEUR_LOGO - hauteurLogo) / 2;
  ctx.drawImage(img, 0, 0, largeurSource, hauteurSource,
    decalageX, decalageY, largeurLogo, hauteurLogo);

  return { url: canvas.toDataURL('image/png'), largeur: width, hauteur: height };
}

export function iconGoogleMapsPointDeVente(img, hauteurAffichee) {
  const marker = iconPointDeVente(img);
  const largeurAffichee = Math.round(hauteurAffichee * (marker.largeur / marker.hauteur));
  return {
    url: marker.url,
    scaledSize: new google.maps.Size(largeurAffichee, hauteurAffichee),
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(largeurAffichee / 2, hauteurAffichee),
  };
}

export function iconPointDeVenteDefaut() {
  const taille = 30;
  return {
    url: require('@/assets/images/icon_marker/marker_default_pdv.png'),
    scaledSize: new google.maps.Size(taille, taille),
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(taille / 2, taille),
  };
}

export function iconMarkerInfoBulle(couleur, azimut, index) {
  return new Promise((resolve) => {
    // Récupération de l'image contenant toute les icônes
    const img = new Image(largeurDuFichier, hauteurDuFichier);
    img.src = require('@/assets/images/icon_marker/icons.png');
  
    img.onload = function () {
      const data = drawBull(img, couleur, azimut, index);
      resolve(data);
    }
  });
}

export async function getIconPdvData(url, hauteurAffichee) {
  const hauteur = hauteurAffichee || siteConfig.default.pdv.taille;
  return new Promise(resolve => {
    const img = document.createElement('img');
    img.setAttribute('crossOrigin', 'Anonymous');
    img.onload = () => {
      const icon = iconGoogleMapsPointDeVente(img, hauteur);
      resolve({
        icon,
        data: icon.url,
        width: icon.scaledSize.width,
      });
    };
    img.onerror = () => {
      img.src = getImgPdv();
    };
    img.setAttribute('src', getImgPdv(url));
  })
}